import translation from 'i18n/translation.json';

export const photoDNIFrontRecommendations = [
  translation.registration.sharpAndClearPhoto,
  translation.registration.fullDNI,
  translation.registration.realPhoto,
  translation.registration.validDNI,
];

export const photoDNIBackRecommendations = [
  translation.registration.sharpAndClearPhoto,
  translation.registration.fullDNI,
  translation.registration.realPhoto,
  translation.registration.validDNI,
];

export const photoSelfieRecommendations = [
  translation.registration.phoneInFront,
  translation.registration.selfieLightSource,
  translation.registration.faceWithoutCover,
  translation.registration.cameraAccess,
];
